import { render, staticRenderFns } from "./SystemBaseBarCode.vue?vue&type=template&id=31d1d28b&scoped=true"
import script from "./SystemBaseBarCode.vue?vue&type=script&lang=js"
export * from "./SystemBaseBarCode.vue?vue&type=script&lang=js"
import style0 from "./SystemBaseBarCode.vue?vue&type=style&index=0&id=31d1d28b&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31d1d28b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\XWork\\ProjectSystem\\铂诺客SaaS\\devicenewweb\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('31d1d28b')) {
      api.createRecord('31d1d28b', component.options)
    } else {
      api.reload('31d1d28b', component.options)
    }
    module.hot.accept("./SystemBaseBarCode.vue?vue&type=template&id=31d1d28b&scoped=true", function () {
      api.rerender('31d1d28b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/System/SystemBaseBarCode/SystemBaseBarCode.vue"
export default component.exports